// Centralized currency formatting.
// Defaults to EUR/pt-PT until multi-tenancy adds per-org config.

const DEFAULT_LOCALE = 'pt-PT';
const DEFAULT_CURRENCY = 'EUR';

const formatter = new Intl.NumberFormat(DEFAULT_LOCALE, {
  style: 'currency',
  currency: DEFAULT_CURRENCY,
});

/** Format a numeric value as currency (e.g. 1234.5 → "1 234,50 €") */
export function formatarMoeda(valor: number): string {
  return formatter.format(valor);
}

/** Currency symbol for labels (e.g. "€") */
export const SIMBOLO_MOEDA = '€';
